import DescrEditor from '@/components/common/DescrEditor.vue'
import ProdEditor from '@/components/common/ProdEditor.vue'
import ChipEditor from '@/components/common/ChipEditor.vue'
import PriceEditor from '@/components/common/PriceEditor.vue'
import Spinner from '@/components/common/Spinner.vue'
import MenuEditor from '@/components/common/MenuEditor.vue'
import ProdEditorFull from '@/components/common/ProdEditorFull.vue'
import ProdSelector from '@/components/common/ProdSelector.vue'
import BreadCrumbMenu from '@/components/common/BreadCrumbMenu.vue'
import TavoloEditor from '@/components/common/BreadCrumbMenu.vue'
import Loading from '@/components/common/Loading.vue'
import MainPriceChanger from '@/components/common/MainPriceChanger.vue'
import AddToCart from '@/components/common/AddToCart.vue'
import ShowCart from '@/components/common/ShowCart.vue'
import ConfirmDelete from '@/components/common/ConfirmDelete.vue'
import TooltipContainer from '@/components/common/TooltipContainer.vue'
import CombCreator from '@/components/common/CombCreator.vue'
import Lock from '@/components/common/Lock.vue'
import Changed from '@/components/common/Changed.vue'
import TerminalDialog from '@/components/common/TerminalDialog.vue'
import OperatorDialog from '@/components/common/OperatorDialog.vue'
import PaymentDialog from '@/components/common/PaymentDialog.vue'
import DiscountDialog from '@/components/common/DiscountDialog.vue'
import PrinterMapDialog from '@/components/common/PrinterMapDialog.vue'
/**
 * Espone tutti i componenti 'common'
 * @module components/common/index
 */
export {
    DescrEditor,
    ProdEditor,
    ChipEditor,
    PriceEditor,
    Spinner,
    MenuEditor,
    ProdEditorFull,
    ProdSelector,
    BreadCrumbMenu,
    TavoloEditor,
    Loading,
    Lock,
    Changed,
    MainPriceChanger,
    AddToCart,
    ShowCart,
    ConfirmDelete,
    TooltipContainer,
    CombCreator,
    TerminalDialog,
    OperatorDialog,
    PaymentDialog,
    DiscountDialog,
    PrinterMapDialog
}


// WEBPACK FOOTER //
// ./src/components/common/index.js